import { IS_A_STRING_AND_NOT_EMPTY, IS_NUMERIC } from '@core/util/check.util'
import { TO_NUMBER } from '@core/util/convert.util'
import { GET_LOCALE } from '@core/util/space.util'
import { TO_STRING } from '@core/util/string.util'
import { FORMAT, GET_TZ } from '@core/util/time.util'
import { DateTime } from 'luxon'

export const FROM_ISO_TO_LOCAL_FORMAT = (_: { iso?: any, format?: string }): string => {
  const m = IS_A_STRING_AND_NOT_EMPTY(TO_STRING(_.iso)) ? DateTime.fromISO(TO_STRING(_.iso)) : DateTime.invalid('iso')
  return m.isValid ? m.setZone(GET_TZ()).toFormat(_.format ?? FORMAT.localYmdHmsZ) : ''
}

export const FROM_ISO_TO_LOCAL_DT = (iso?: any): string => FROM_ISO_TO_LOCAL_FORMAT({ iso, format: FORMAT.localYmdHm })

export const FROM_ISO_TO_LOCAL_DTT = (iso?: any): string => FROM_ISO_TO_LOCAL_FORMAT({ iso, format: FORMAT.localYmdHms })

export const FROM_ISO_TO_LOCAL_D = (iso?: any): string => FROM_ISO_TO_LOCAL_FORMAT({ iso, format: FORMAT.localYmd })

export const FROM_ISO_TO_LOCAL_T = (iso?: any): string => FROM_ISO_TO_LOCAL_FORMAT({ iso, format: FORMAT.localHm })

export const FROM_ISO_TO_LOCAL_TT = (iso?: any): string => FROM_ISO_TO_LOCAL_FORMAT({ iso, format: FORMAT.localHms })

export const TO_LOCAL_NUMBER = (x?: any): string => IS_NUMERIC(x) ? TO_NUMBER(x).toLocaleString(GET_LOCALE()) : ''

export const TO_LOCAL_NUMBER_WITH_2_F_DIGITS = (x?: any): string => {
  return IS_NUMERIC(x) ? TO_NUMBER(x).toLocaleString(GET_LOCALE(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
}

export const TO_LOCAL_NUMBER_WITH_1_F_DIGIT = (x?: any): string => {
  return IS_NUMERIC(x) ? TO_NUMBER(x).toLocaleString(GET_LOCALE(), { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : ''
}

export const FROM_UNIX_TO_LOCAL_FORMAT = (_: { unix?: any, format?: string }): string => {
  const m = IS_NUMERIC(_.unix) ? DateTime.fromSeconds(TO_NUMBER(_.unix)) : DateTime.invalid('unix')
  return m.isValid ? m.setZone(GET_TZ()).toFormat(_.format ?? FORMAT.localYmdHmsZ) : ''
}

export const FROM_UNIX_TO_LOCAL_DT = (unix?: any): string => FROM_UNIX_TO_LOCAL_FORMAT({ unix, format: FORMAT.localYmdHm })

export const FROM_UNIX_TO_LOCAL_DTT = (unix?: any): string => FROM_UNIX_TO_LOCAL_FORMAT({ unix, format: FORMAT.localYmdHms })

export const FROM_UNIX_TO_LOCAL_D = (unix?: any): string => FROM_UNIX_TO_LOCAL_FORMAT({ unix, format: FORMAT.localYmd })

export const FROM_UNIX_TO_LOCAL_T = (unix?: any): string => FROM_UNIX_TO_LOCAL_FORMAT({ unix, format: FORMAT.localHm })

export const FROM_UNIX_TO_LOCAL_TT = (unix?: any): string => FROM_UNIX_TO_LOCAL_FORMAT({ unix, format: FORMAT.localHms })
